<template>
    <div class="filling-goods-div">
        <div style="padding-top: 5px; font-size: 16px">蓝牙连接</div>
        <span style="color: red" v-if="hostcs">测试服</span>
        <div style="margin-top: 30px;">
            <div class="bluetooth">
                <div style="font-size: 14px;">蓝牙地址: </div>
                <input id="bluetooth" class="bluetoothLink-input" @keyup.enter="goLink()" v-model="Bluetooth"
                    ref="getIDInpot" />
            </div>
            <div class="bluetooth">
                <div style="font-size: 14px;">上次蓝牙地址: </div>
                <div style="width: 70%;font-size: 14px;">{{ LastBluetooth }}</div>
            </div>
        </div>
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button type="info" class="bottom-button-b" @click="goLink()">发送蓝牙地址</van-button>
        </div>
    </div>
</template>
  
<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import html2canvas from 'html2canvas';
import moment from 'moment';
export default {
    name: "bluetoothLink",
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            username: "",
            lasttime: '',
            Bluetooth: '',
            LastBluetooth: '',
        };
    },
    mounted() {
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        this.LastBluetooth = window.localStorage.getItem("Bluetooth");
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.66 + "px;overflow:scroll";
        setTimeout(() => {
            this.focus();
        }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
    },
    methods: {
        goLink() {
            if (this.Bluetooth) {
                localStorage.setItem('Bluetooth', this.Bluetooth);
                this.LastBluetooth = this.Bluetooth;
                console.log(localStorage.getItem('Bluetooth'));
                alert(this.Bluetooth);
            }else{
                Toast('地址不能为空！')
            }
        },
        focus() {
            this.$refs.getIDInpot.focus();
        },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
        go_scan_url() {
            let url =
                "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
            window.location.href = url;
        },
    },
};
</script>
  
<style lang="less">
@import "../style/outOrderInfo.less";

.bluetooth {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin-top: 50px;
}

.bluetoothLink-input {
    height: 22px;
    width: 4rem;
    width: 70%;
}

.bottom-button-b {
    width: auto;
}
</style>